<mat-card>
	<mat-card-title [innerText]="cardTitle | translate"></mat-card-title>
	<mat-card-content [formGroup]="formGroupNotiz" style="max-height: 65vh; overflow-y: auto; overflow-x: hidden">
		<span class="row">
			<mat-checkbox class="cbInaktiv-margin" formControlName="fldErledigt" style="flex: 1;">
				{{ "MAIN_APP_PENDENZEN_NOTIZ.erledigt" | translate }}
			</mat-checkbox>
			
			<mat-checkbox formControlName="fldPrivat" style="flex: 1;">
				{{ "MAIN_APP_PENDENZEN_NOTIZ.privat" | translate }}
			</mat-checkbox>
		</span>
		
		<span class="row">
			<mat-form-field>
				<mat-label>
					{{ "MAIN_APP_PENDENZEN_NOTIZ.kategorien" | translate }}
				</mat-label>
				<mat-select [multiple]="true" formControlName="fldKategorie">
					<mat-option *ngFor="let kate of dbKategorien" [value]="kate.id">
						{{ kate.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>
			
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_NOTIZ.objekt" | translate }}</mat-label>
				<input [matAutocomplete]="auto" aria-label="Suche" formControlName="fldObjekt" matInput placeholder="Objekt wählen" required type="text"/>
				<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedSearchItem($event)" [displayWith]="getObjektDesc" autoActiveFirstOption>
					<mat-option *ngFor="let objekt of filteredDescriptions | async" [value]="objekt">
						{{ objekt.beschreibung }}
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</span>
		
		<span class="row">
			<span class="row">
				<mat-form-field>
					<mat-label>{{ "MAIN_APP_PENDENZEN_NOTIZ.adresse" | translate }}</mat-label>
					<mat-select (selectionChange)="selectedAdress($event)" formControlName="fldAdresse" placeholder="Adresse wählen">
						<mat-option *ngFor="let adress of objectAddresses" [value]="adress">
							{{ adress.zusammenfassung }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<mat-icon (click)="addObjectAddress()" style="width: 28px">import_contacts</mat-icon>
			</span>
			
			
			<mat-form-field>
				<mat-label>{{
						"MAIN_APP_PENDENZEN_NOTIZ.zuständig" | translate
					}}
				</mat-label>
				<mat-select [multiple]="true" [required]="true" formControlName="fldMitarbeiter">
					<mat-option *ngFor="let employee of dbMitarbeiter" [value]="employee.userID">{{ getMitarbeiter(employee) }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</span>
		
		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_NOTIZ.titel" | translate }}</mat-label>
				<input formControlName="fldTitel" matInput/>
			</mat-form-field>
		</span>
		
		<span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_PENDENZEN_NOTIZ.notiz" | translate }}</mat-label>
				<textarea formControlName="fldNotiz" matInput style="min-height: 150px"></textarea>
			</mat-form-field>
		</span>
	
	</mat-card-content>
	<mat-dialog-actions>
		<button (click)="save()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
		<button [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-dialog-close mat-stroked-button></button>
	</mat-dialog-actions>

</mat-card>
